/* eslint-disable quote-props */
import { defineRecipe } from "@chakra-ui/react";

const radioMarkRecipe = defineRecipe({
  className: "chakra-radiomark",
  base: {
    borderRadius: "62px",
    cursor: "pointer",
    _hover: {
      cursor: "pointer",
    },
    border: "2px solid",
    borderColor: "lines",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "lines",
  },
  variants: {
    variant: {
      legacy: {
        borderColor: "danger.500",
        _invalid: {
          borderColor: "text.action",
        },
        _checked: {
          borderColor: "button.border.filled",
        },
      },
      outline: {
        borderColor: "lines",
        _invalid: {
          borderColor: "error.element",
        },
        _checked: {
          borderColor: "button.border.hollow",
          _dark: {
            bg: "base.200",
          },
          "& .dot": {
            bg: "button.border.hollow",
            border: "2px solid",
            scale: 1,
            _dark: {
              bg: "action.600",
              borderColor: "button.border.hollow",
            },
          },
        },
        _disabled: {
          layerStyle: "disabled",
          backgroundColor: "base.400",
          borderColor: "lines",
          cursor: "not-allowed",
          color: "text.soft",
        },
      },
    },
    size: {
      xs: {
        boxSize: "3",
      },
      sm: {
        height: "32px",
        width: "32px",
        "& .dot": {
          height: "24px",
          width: "24px",
        },
      },
      md: {
        boxSize: "5",
      },
      lg: {
        height: "48px",
        width: "48px",
        "& .dot": {
          height: "36px",
          width: "36px",
        },
      },
    },
  },
  defaultVariants: {
    variant: "legacy",
    size: "sm",
  },
});

export default radioMarkRecipe;
